import {useNavigate, BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Clarity from '@microsoft/clarity';

import MoviePage from './components/MoviePage';
import StartButton from './components/StartButton';
import Wizard from './components/wizard/Wizard';
import Result from './components/Result';
import Header from './components/Header';
import Footer from './components/Footer';
import About from './components/About';
import FAQ from './components/FAQ';
import './styles.css';

const projectId = "stav6zrwfe"

Clarity.init(projectId);

const App = () => {
    return (
        <Router>
            <div className="App">
                <Header/>
                <Routes>
                    <Route path="/" element={<StartButton />} />
                    <Route path="/movie/:id" element={<MoviePage />} />
                    <Route path="/findyourmovie" element={<Wizard steps={0}/>}/>
                    <Route path="/search" element={<Result />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/faq" element={<FAQ />} />
                </Routes>
                <Footer/>
            </div>
        </Router>
    );
}

export default App;

